import { MutuoSeleccionado } from "../models/MutuoSeleccionado";
import { columns } from "../../../dtos/columns";
import { format } from "rut.js";
import { Chip } from "@mui/material";

const mapEstado = (estado?: string) => {
    if (estado === 'exitoso') return { label: 'Exitoso', color: 'success' as const };
    if (estado === 'fallido') return { label: 'Fallido', color: 'error' as const };
    if (estado === 'procesando') return { label: 'Procesando', color: 'warning' as const };

    return { label: 'Pendiente', color: 'default' as const };
};

export function useColumnsResults() {

    const COLUMNS: columns<MutuoSeleccionado>[] = [
        {
            name: 'N° Solicitud',
            selector: (row: MutuoSeleccionado) => row.numeroSolicitud,
            sortable: true,
            sortField: 'numeroSolicitud',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tipo mutuo',
            selector: (row: MutuoSeleccionado) => row.tipoMutuo,
            sortable: true,
            sortField: 'tipoMutuo',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Nombre o razón social',
            selector: (row: MutuoSeleccionado) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'RUT',
            selector: (row: MutuoSeleccionado) => format(row.rut!),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Estado',
            selector: (row: MutuoSeleccionado) => row.estadoActivacion ?? 'pendiente',
            cell: (row: MutuoSeleccionado) => {
                const estado = mapEstado(row.estadoActivacion);
                return <Chip label={estado.label} color={estado.color} size="small" />;
            },
            sortable: true,
            sortField: 'estadoActivacion',
            wrap: true,
            alling: 'left',
            export: false,
        },
        {
            name: 'Observaciones',
            selector: (row: MutuoSeleccionado) => row.observacion,
            sortable: true,
            sortField: 'observacion',
            wrap: true,
            alling: 'left',
            export: true,
        }
    ]

    return { COLUMNS };
}